// extracted by mini-css-extract-plugin
export default {"list":"VerifiedEvents_list__xx-+A","empty":"VerifiedEvents_empty__-hRCm"};